import {Button, Drawer} from "antd";
import {GetStoreServicesOrdersApiResponse} from "../../../../../../../../react-query-hooks/store/services/get-orders/types";
import {CloseOutlined} from "@ant-design/icons";
import {ServiceOrderWorkDeliveryDeliverWork} from "./deliver-work";
import {StyledStoreServiceOrderDrawer} from "../../../../customer/drawer/styles";

type StoreServiceOrderDeliverWorkDrawerProps = {
  open: boolean;
  orderDetails: GetStoreServicesOrdersApiResponse["orders"][0] | null;
  onBack: () => void;
  onClose: () => void;
};

export function StoreServiceOrderDeliverWorkDrawer({
  onBack,
  onClose,
  open,
  orderDetails,
}: StoreServiceOrderDeliverWorkDrawerProps) {
  if (!orderDetails) return null;
  return (
    <StyledStoreServiceOrderDrawer
      title={`Deliver work for ${orderDetails.productService.name}`}
      placement="right"
      onClose={onClose}
      visible={open}
      closable={false}
      extra={
        <Button size="small" type="text" onClick={onClose}>
          <CloseOutlined />
        </Button>
      }
    >
      <ServiceOrderWorkDeliveryDeliverWork />
    </StyledStoreServiceOrderDrawer>
  );
}
